import { useCallback, useEffect, useState } from 'react'

import type { UserIdentity } from './utils/brazeHelpers'
import { initializeBraze, setUserIdentity, trackEvent } from './utils/initializeBraze'

interface UseBrazeReturn {
  setUserIdentity: (user: UserIdentity) => void
  trackEvent: (eventName: string, properties?: Record<string, any>) => void
  isInitialized: boolean
}

export const useBraze = (): UseBrazeReturn => {
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    const result = initializeBraze()
    setIsInitialized(result)
  }, [])

  const setUserIdentityWrapper = useCallback((user: UserIdentity) => {
    setUserIdentity(user)
  }, [])

  const trackEventWrapper = useCallback((eventName: string, properties?: Record<string, any>) => {
    trackEvent(eventName, properties)
  }, [])

  return {
    setUserIdentity: setUserIdentityWrapper,
    trackEvent: trackEventWrapper,
    isInitialized,
  }
}
